module.exports = __webpack_public_path__ + "img/camper_interiour_4.5b01f554.jpg";